import { KeyValuePair } from ".";

export class Dictionary<TKey, TValue> {
  private _pairs: KeyValuePair<TKey, TValue>[] = [];

  public set(key: TKey, value: TValue): void {
    if (!key) { throw new Error("key is empty!!!"); }
    const found = this._pairs.find(p => p.key === key);
    if (found) {
      found.value = value;
    } else {
      const pair = new KeyValuePair<TKey, TValue>();
      pair.key = key;
      pair.value = value;
      this._pairs.push(pair);
    }
  }

  public get(key: TKey): TValue {
    if (!key) { throw new Error("key is empty!!!"); }
    const found = this._pairs.find(p => p.key === key);
    if (!found) { throw new Error("item not found!!!"); }
    return found.value;
  }

  public remove(key: TKey): void {
    if (!key) { throw new Error("key is empty!!!"); }
    const index = this.getIndex(this._pairs, key);
    if (index < 0) { return; }
    this._pairs.splice(index, 1);
  }

  private getIndex(pairs: KeyValuePair<TKey, TValue>[], key: TKey): number {
    for (let index = 0; index < pairs.length; ++index) {
      const pair = pairs[index];
      if (pair.key === key) { return index; }
    }
    return -1;
  }

  public containsKey(key: TKey): boolean {
    if (!key) { throw new Error("key is empty!!!"); }
    const found = this._pairs.find(p => p.key === key);
    return !!found;
  }

  public get keys(): TKey[] {
    return this._pairs.map(pair => pair.key);
  }
}
